var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { css } from "@emotion/css";
var colorArray = [
    "#000",
    "#c92a2a",
    "#9775fa",
    "#364fc7",
    "#4dabf7",
    "#38d9a9",
    "#69db7c",
    "#ffd43b",
    "#ffa94d",
];
var ColorPalte = function (props) {
    var ColorBlocksArray = useMemo(function () {
        return colorArray.map(function (blockColor) { return (_jsx(ColorBlock, { color: blockColor, cb: props.cb }, blockColor)); });
    }, []);
    return (_jsx("div", __assign({ className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: absolute;\n        box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);\n        top: 0;\n        left: 0;\n        display: grid;\n        z-index: 10;\n        grid-template-columns: repeat(3, 1fr);\n        overflow: hidden;\n        transform: translate(10%, 30%);\n      "], ["\n        position: absolute;\n        box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);\n        top: 0;\n        left: 0;\n        display: grid;\n        z-index: 10;\n        grid-template-columns: repeat(3, 1fr);\n        overflow: hidden;\n        transform: translate(10%, 30%);\n      "]))) }, { children: ColorBlocksArray })));
};
var ColorBlock = function (_a) {
    var color = _a.color, cb = _a.cb;
    return (_jsx("div", { className: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        width: 30px;\n        height: 30px;\n        background-color: ", ";\n        transition: all 0.3s;\n        cursor: pointer;\n        &:hover {\n          box-shadow: inset 0 0 2px 3px #fff;\n        }\n      "], ["\n        width: 30px;\n        height: 30px;\n        background-color: ", ";\n        transition: all 0.3s;\n        cursor: pointer;\n        &:hover {\n          box-shadow: inset 0 0 2px 3px #fff;\n        }\n      "])), color), onMouseDown: function () {
            cb(color);
        } }));
};
export default ColorPalte;
var templateObject_1, templateObject_2;
